import React, { useState, useEffect } from "react";
import { statusClass } from "./utils";

function InfoBox(props) {
  return (
    <div className="info-box-panel panel panel-default">
      <div className="panel-heading">
        <button type="button" className="close" aria-label="Close" onClick={props.onClose}><span aria-hidden="true">&times;</span></button>
        <h4 className="panel-title">
          {props.detailTitle}
        </h4>
      </div>
      <div className="panel-body">
        {props.badges && (
          <div className="sticker-bar">
            {props.badges}
          </div>
        )}
        {props.body}
      </div>

      {props.footer && (
        <div className="panel-footer">
          {props.footer}
        </div>
      )}
    </div>
  )
}

export default InfoBox;